import { useSuspenseQuery } from "@apollo/client/react";

import { GetTenantsDocument, type GetTenantsQuery, type GetTenantsQueryVariables } from "~/features/admin/tenants/gqls";

/**
 * Read-only list of tenants, optionally narrowed by a Hasura `where` filter
 * (used to filter by member). Tenants are an admin-level resource, so the query
 * carries no tenantId.
 */
export function useTenantList(where: GetTenantsQueryVariables["where"]) {
  return useSuspenseQuery<GetTenantsQuery, GetTenantsQueryVariables>(GetTenantsDocument, {
    variables: { where },
  });
}
